(function () {
  const rush_order_product = JSON.parse(document.getElementById('addonJSON').textContent);
  const rush_order_product_id = rush_order_product.id;
  const cart_el = $('body');

  const updateRushOrderProduct = function(variant_id, quantity) {
    let updates = {};
    updates[variant_id] = quantity;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(cart => {
      return cart.json();
    })
    .then(cart => {
      // sessionStorage.setItem("rush_order", true);
      if(location.href.includes('/cart')) cartPageUpdate(cart);
      else buildCart(cart, true);
      // setTimeout(function(){
      //   sessionStorage.removeItem("rush_order");
      // }, 2000);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  cart_el.on('change', '#rush-order-checkbox', function() {
    var variant_id = false;
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(cart => {
      return cart.json();
    })
    .then(cart => {
      var cart_total = cart.total_price / 100;
      var variant = false;
      var min = 0;
      var max = 0;
      var rush_order_variants = rush_order_product.variants;
      var current_rush_order_price = 0;
      cart.items.forEach(item => {
        if(item.product_id == rush_order_product_id) {
          variant_id = item.id;
          current_rush_order_price = item.final_line_price / 100;
        }
      });
      for (let i = 0; i < rush_order_variants.length; i++) {
        variant = rush_order_variants[i];
        var min_max = variant.title.replace(" ","").split("-");
        min = parseInt(min_max[0]) - 0.99;
        max = parseInt(min_max[1]);
        let new_cart_total = cart_total - current_rush_order_price;
        if(min < new_cart_total && max > new_cart_total) break;
      }

      if(this.checked && !variant_id) {
        updateRushOrderProduct(variant.id, 1);
      } else if(this.checked && variant_id) {
        
      } else {
        updateRushOrderProduct(variant_id, 0);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
  document.addEventListener('cart:update', function(e) {
    var cart = e.detail.cart;
    var rush_order_variant = false;
    var current_rush_order_price = 0;
    var cart_total = cart.total_price / 100;
    var variant = false;
    var min = 0;
    var max = 0;
    var rush_order_variants = rush_order_product.variants;
    cart.items.forEach(item => {
      if(item.product_id == rush_order_product_id) {
        rush_order_variant = item.id;
        current_rush_order_price = item.final_line_price / 100;
      }
    });
    for (let i = 0; i < rush_order_variants.length; i++) {
      variant = rush_order_variants[i];
      var min_max = variant.title.replace(" ","").split("-");
      min = parseInt(min_max[0]) - 0.99;
      max = parseInt(min_max[1]);
      let new_cart_total = cart_total - current_rush_order_price;
      if(min < new_cart_total && max > new_cart_total) break;
    }
    if($('#rush-order-checkbox').prop('checked')) {
      console.log('is_checked')
      if(rush_order_variant && rush_order_variant != variant.id) {
        updateRushOrderProduct(rush_order_variant, 0);
        updateRushOrderProduct(variant.id, 1);
      } else if(!rush_order_variant) {
        updateRushOrderProduct(variant.id, 1);
      } else if(rush_order_variant == variant.id) {
        
      }
    } else {
      // updateRushOrderProduct(rush_order_variant, 0);
    }
  });
})();